export default {
    dashboards: {
        active: require('@/assets/images/dashboard_icon_active.svg'),
        inactive: require('@/assets/images/dashboard_icon.svg'),
        hover: require('@/assets/images/dashboard_icon_hover.svg')
    },
    whitelisting: {
        active: require('@/assets/images/cta_icon_active.svg'),
        inactive: require('@/assets/images/cta_icon.svg'),
        hover: require('@/assets/images/cta_icon_hover.svg'),
        email: require('@/assets/images/cta-email.svg'),
        url: require('@/assets/images/cta-url.svg'),
        mobile: require('@/assets/images/cta-mobile.svg')
    },
    urlShortener: {
        active: require('@/assets/images/links_icon_active.svg'),
        inactive: require('@/assets/images/links_icon.svg'),
        hover: require('@/assets/images/links_icon_hover.svg')
    },
    domains: {
        active: require('@/assets/images/custom_domains_icon_active.svg'),
        inactive: require('@/assets/images/custom_domains_icon.svg'),
        hover: require('@/assets/images/custom_domains_icon_hover.svg'),
        domain_active: require('@/assets/images/domain-active.svg'),
        domain_inactive: require('@/assets/images/domain.svg'),
        dns_active: require('@/assets/images/dns-active.svg'),
        dns_inactive: require('@/assets/images/dns.svg'),
        verify_active: require('@/assets/images/verify-active.svg'),
        verify_inactive: require('@/assets/images/verify.svg')
    },
    analytics: {
        active: require('@/assets/images/analytics_icon_active.svg'),
        inactive: require('@/assets/images/analytics_icon.svg'),
        hover: require('@/assets/images/analytics_icon_hover.svg')
    },
    webhook: {
        active: require('@/assets/images/webhook_icon_active.svg'),
        inactive: require('@/assets/images/webhook_icon.svg'),
        hover: require('@/assets/images/webhook_icon_hover.svg')
    },
    settings: {
        active: require('@/assets/images/settings_icon_active.svg'),
        inactive: require('@/assets/images/settings_icon.svg'),
        hover: require('@/assets/images/settings_icon_hover.svg')
    }
}
